import { NavLink } from 'react-router';

import { cx } from '../lib/cx.ts';
import { NAV_ITEMS } from './nav.ts';

/** Bottom tab bar. Phone and tablet only — the side rail replaces it at 900px. */
export function TabBar() {
  return (
    <nav
      aria-label="Main"
      className={cx(
        'fixed inset-x-0 bottom-0 z-40 border-t border-line bg-surface',
        'pb-[env(safe-area-inset-bottom)] rail:hidden',
      )}
    >
      <ul className="mx-auto flex max-w-content">
        {NAV_ITEMS.map(({ to, label, Icon }) => (
          /*
           * `flex-auto`, not `flex-1`: the tabs size to their labels and
           * share out what is left, so "Dashboard" stays whole at an ordinary
           * text size. `min-w-0` then lets them shrink and truncate when a
           * reader has scaled their text up, instead of widening the bar and
           * colliding with each other.
           */
          <li key={to} className="min-w-0 flex-auto">
            <NavLink
              to={to}
              className={({ isActive }) =>
                cx(
                  'flex h-tabbar flex-col items-center justify-center gap-1',
                  'text-xs font-medium transition-colors duration-(--ui-duration-fast)',
                  isActive ? 'text-accent' : 'text-faint hover:text-text',
                )
              }
            >
              {({ isActive }) => (
                <>
                  <Icon className="size-6 shrink-0" />
                  {/* Truncates rather than colliding with the next tab when a
                      reader has scaled their text up. */}
                  <span className="max-w-full truncate px-0.5">{label}</span>
                  <span className="sr-only">{isActive ? '(current)' : ''}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
